import FileUploadsInProgress from 'Enrollment/components/UploadEnrollmentApplications/FileUploadInProgress';
import {hasAbilityToUploadEnrollmentApplications} from 'Enrollment/components/UploadEnrollmentApplications/UploadEnrollmentApplications';
import React from 'react';
import {useSelector} from 'react-redux';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

const FileUploadProgressIndicator = () => {
  const scopes = useSelector(selectUserScopes);
  return hasAbilityToUploadEnrollmentApplications(scopes) ? <FileUploadsInProgress /> : null;
};

export default FileUploadProgressIndicator;
